import React from 'react';
import { Checkbox as AkCheckbox } from '@atlaskit/checkbox';
import { CheckboxField as AkCheckboxField } from '@atlaskit/form';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	defaultIsChecked: boolean;
} & {
	fieldName: string;
	setDaySelected: (isDaySelected: boolean) => void;
};

const DayCheckboxView = ({ fieldName, defaultIsChecked, setDaySelected }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<AkCheckboxField name={fieldName} defaultIsChecked={defaultIsChecked}>
			{({ fieldProps }) => (
				<AkCheckbox
					{...fieldProps}
					onChange={({ target: { checked } }) => {
						setDaySelected(checked);
					}}
					// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ sunday: MessageDescriptorV2; saturday: MessageDescriptorV2; friday: MessageDescriptorV2; thursday: MessageDescriptorV2; wednesday: MessageDescriptorV2; tuesday: MessageDescriptorV2; monday: MessageDescriptorV2; }'.
					label={formatMessage(messages[fieldName])}
					testId={`servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.${fieldName}`}
				/>
			)}
		</AkCheckboxField>
	);
};

export const DayCheckbox = DayCheckboxView;
